<template>
  <div class="py-2 px-6">
    <div class="flex justify-between mx-3 my-7">
      <div class="flex"><logo-icon></logo-icon></div>
      <div class="cursor-pointer lowercase text-primary">
        <p>www.{{ tenantName }}.com</p>
      </div>
    </div>
    <div class="mt-2 p-4">
      <div class="my-4">
        <span class="font-bold">Business Name:</span> <br />
        <span>{{ business.name }}</span>
      </div>
      <div class="my-4">
        <span class="font-bold">Email:</span> <br />
        <span>{{ business.email }}</span>
      </div>
      <div>
        <div>
          <div class="my-4 pb-6">
            <span class="font-bold">Time & Date</span> <br />
            <span>
              {{ $dayjs(newDate).format('hh:mm A | DD-MMM-YYYY') }}
            </span>
          </div>
          <div
            class="border w-full border-gray-14 p-4 my-6 rounded-md shadow-md"
          >
            <div class="font-bold mb-4 text-base">Oval terminal transfer</div>
            <div>
              <div class="w-3/5 mt-10 pl-3">
                <div class="flex justify-between pb-2">
                  <p class="text-13px font-normal">You send exactly</p>
                  <p class="text-base font-bold ml-1">
                    {{
                      parseMoneyLocal(
                        transferDetails.debitAmount +
                          transferDetails.partnerCommission,
                        country.symbol
                      )
                    }}
                    {{ country.currency }}
                  </p>
                </div>
                <div class="flex justify-between pb-2">
                  <p class="text-13px font-normal">Our fees</p>
                  <p class="text-13px font-normal ml-9">
                    {{ parseMoneyLocal(transferDetails.fees, country.symbol) }}
                  </p>
                </div>
                <div class="flex justify-between pb-2">
                  <p class="text-13px font-normal">My Commission</p>
                  <p class="text-13px font-normal ml-2">
                    {{
                      parseMoneyLocal(
                        transferDetails.partnerCommission,
                        country.symbol
                      )
                    }}
                  </p>
                </div>
                <div class="flex justify-between pb-2">
                  <p class="text-13px font-normal">Exchange rate</p>
                  <p class="text-13px font-normal ml-4">
                    1
                    {{
                      !this.isDivisionOperator
                        ? activeCurrency
                        : secondaryCurrency
                    }}
                    = {{ exchangeRateBase }}
                    {{
                      !this.isDivisionOperator
                        ? secondaryCurrency
                        : activeCurrency
                    }}
                  </p>
                </div>
                <div class="flex justify-between pb-2">
                  <p class="text-13px font-normal">Amount Converted</p>
                  <p class="text-13px font-normal">
                    {{
                      parseMoneyLocal(
                        transferDetails.debitAmount - transferDetails.fees,
                        country.symbol
                      )
                    }}
                  </p>
                </div>
                <div class="flex justify-between pb-2">
                  <p class="text-13px font-normal">
                    {{ recipientInfo.recipientName || 'Recipient' }} gets
                  </p>
                  <p class="text-base font-bold ml-3">
                    {{ convertValueTo2DP(transferDetails.recipientAmount) }}
                    {{ secondaryCurrency }}
                  </p>
                </div>
              </div>
              <div class="underline underline-offset-8 mt-6 mb-2">
                Bank Account
              </div>
              <div>
                Account name: <span>{{ paymentDetails.accountName }}</span>
              </div>
              <div>
                Account number:
                <span>{{ paymentDetails.accountNumber }}</span>
              </div>
              <div>
                Bank name: <span>{{ paymentDetails.bankName }}</span>
              </div>
              <div>
                Reference: <span>{{ transferReference }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <div class="italic font-semibold">Disclaimer</div>
        <div style="word-break: normal" class="italic text-xs">
          This document is strictly confidential communication to and solely for
          the use of the recipient and may not be reproduced or circulated
          without {{ tenantName }} prior written consent. If you are not
          intended recipient, you may not disclose or use the information in
          this documentation in any way.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import localDeposit from '@/mixins/localDeposit.js'
import {
  ParseLocalToUsd,
  ParseMoneyNaira,
  ParseMoneyLocal,
  ConvertValueToXDP
} from '@/utils/helpers'
export default {
  mixins: [localDeposit],
  data () {
    return {
      newDate: Date.now()
    }
  },
  methods: {
    parseMoneyLocal (val, symbol) {
      return ParseMoneyLocal(val, symbol)
    },
    parseMoneyNaira (val) {
      return ParseMoneyNaira(val)
    },
    parseLocalToUsd (val) {
      return ParseLocalToUsd(val, this.exchangeRate)
    },
    convertValueTo2DP (val) {
      return ConvertValueToXDP(val, 2)
    }
  },
  components: {
    logoIcon: () => import('@/assets/images/AppLogo.vue')
  },
  computed: {
    tenantName () {
      return process.env.VUE_APP_TENANT_TITLE
    },
    recipientInfo () {
      return (
        this.$store.state.terminal.transferTerminalDetails
          .recipientInformation || {}
      )
    },
    transferDetails () {
      return (
        this.$store.state.terminal.transferTerminalDetails.transferDetails || {}
      )
    },
    transferReference () {
      return this.$store.state.terminal.transferInfo.localDepositRef
    },
    paymentDetails () {
      const details = this.getLocalDepositDetails(
        this.country.currency,
        this.country2.currency
      )
      return details.account_details
    },
    business () {
      return this.$store.state.auth.business
    }
  }
}
</script>
<style scoped></style>
